import { isElectron } from '@web-chat-core/ui-kit/helpers/electron';
import { AssetPaths } from '../types/backgroundProcessor';

const PATH_PREFIX = isElectron ? '' : '/';

export const getAssetPaths = (): AssetPaths => ({
    tasksVisionFileSet: `${PATH_PREFIX}mediapipe/task-vision/wasm`,
    modelAssetPath: `${PATH_PREFIX}mediapipe/task-vision/selfie_segmenter_landscape.tflite`,
});
